import {dispatchAsync} from 'redux/common';
import api from 'api';
import {keyTypes} from '.';
import ApiService from 'api/ApiService';
import {DialogCallbacks} from 'types/common';
import types from 'redux/keys/types';
import {action} from 'redux/helpers';
import {ICreateOpenPGPKeyPair} from 'types/diplomat/keys/CreateOpenPGPKeyPair';
import {IAddOpenPGPSubKey} from 'types/diplomat/keys/AddOpenPGPSubKey';
import {CreateSSHKeyPair} from 'types/diplomat/keys/CreateSSHKeyPair';
import qs from 'query-string';
import {DiplomatKey} from 'types/DiplomatKey';
import {pushSuccessToast} from 'features/notifications/redux/actions';
import i18n from 'i18n';
import {pageActions} from 'features/layout/CommonPage/redux';
import {ISSLServerCertificate} from 'types/SSLServerCertificate';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {IDiplomatObject} from 'types/DiplomatObject';

const moveKeys = (keyIds: string[], folderId: string, cbs?: DialogCallbacks) =>
   dispatchAsync(api.keysMove, keyTypes.MOVE_KEYS, {
      ...cbs,
      getMethod: ApiService.postSecureJson,
      data: {
         keyIds,
         folderId,
      },
   });

const releaseKey = (data: any) => action(types.RELEASE_KEY, data);
const suspendKey = (data: any) => action(types.SUSPEND_KEY, data);
const createSSHKeyPair = (
   values: CreateSSHKeyPair,
   helpers: FormOnSubmitHelpers<CreateSSHKeyPair>
) => action(types.CREATE_SSH_KEY_PAIR.REQUEST, values, helpers);
const startPollSSHKeyPairStatus = (
   keyName: string,
   helpers: FormOnSubmitHelpers<CreateSSHKeyPair>
) => action(types.START_POLL_SSH_KEY_PAIR_STATUS, keyName, helpers);
const stopPollSSHKeyPairStatus = () => action(types.STOP_POLL_SSH_KEY_PAIR_STATUS);
const createKeyPair = (
   values: ICreateOpenPGPKeyPair,
   helpers: FormOnSubmitHelpers<ICreateOpenPGPKeyPair>
) => action(types.CREATE_OPEN_PGP_KEY_PAIR.REQUEST, values, helpers);

const updatePgpKey = (data: DiplomatKey) =>
   dispatchAsync(
      qs.stringifyUrl({
         url: `${api.pgpKeys}/${data.id}/expirationnotification`,
         query: {
            include: String(data.expirationNotification),
         },
      }),
      keyTypes.UPDATE_PGP_KEY,
      {
         getMethod: ApiService.postSecureJson,
         onSuccess: (res, dispatch) => {
            dispatch!(pushSuccessToast(i18n.t('Key {{name}} saved', {name: data.name})));
            dispatch!(pageActions.flushDirtyValuesGetter(data.id, data.objectType));
         },
      }
   );
const updateSslCert = (data: ISSLServerCertificate) =>
   dispatchAsync(
      qs.stringifyUrl({
         url: `${api.sslKeys}/${data.id}/expirationnotification`,
         query: {
            include: String(data.expirationNotification),
         },
      }),
      keyTypes.UPDATE_SSL_CERT,
      {
         getMethod: ApiService.postSecureJson,
         onSuccess: (res, dispatch) => {
            dispatch!(pushSuccessToast(i18n.t('SSL Cert {{name}} saved', {name: data.name})));
            dispatch!(pageActions.flushDirtyValuesGetter(data.id, data.objectType));
         },
      }
   );

const replaceKey = (data: IDiplomatObject) => action(types.REPLACE_KEY.SAGA, data);

const keyActions = {
   moveKeys,
   releaseKey,
   suspendKey,
   createSSHKeyPair,
   startPollSSHKeyPairStatus,
   stopPollSSHKeyPairStatus,
   createKeyPair,
   updatePgpKey,
   updateSslCert,
   replaceKey,
};

export default keyActions;
